<div class="card px-12 health-check-card mb-10">
    <div class="row mb-3">
        <div class="col-9" role="region" aria-labelledby="availabilityHeading" aria-live="polite">

            <!-- Heading -->
            <p id="availabilityHeading" class="user-title-m fs-16">
                Availability health check
            </p>

            <!-- Description -->
            <p id="availabilityDescription" class="mb-5 txt-regular fs-12">
                <strong>
                    {{ stats?.hasnotindicated_count }} of the next 30 days
                </strong>
                do not have availability indicated.
                Please update your availability.
            </p>

            <!-- Button -->
            <button *ngIf="stats?.availability_check" type="button" class="user-title c-p clr-cc-vilot avail-modal"
                (click)="openQuickAvailabilityModal()" aria-describedby="availabilityDescription">
                Quickly update your availability
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                    class="bi bi-arrow-right" viewBox="0 0 16 17" stroke="currentColor" stroke-width="1"
                    aria-hidden="true" focusable="false">
                    <path fill-rule="evenodd"
                        d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                </svg>
            </button>

        </div>
        <div class="col-3 text-end">
            <div class="progress-circle-container">
                <svg class="progress-ring" width="80" height="80">
                    <circle class="progress-ring__background" cx="40" cy="40" r="35" />
                    <circle class="progress-ring__circle" cx="40" cy="40" r="35" stroke="#4caf50" stroke-width="8"
                        fill="none" [attr.stroke-dasharray]="
                      getSmallProfileDashArray(
                        stats?.hasnotindicated_percentage
                      )
                    " [attr.stroke-dashoffset]="
                      getSmallProfileDashOffset(
                        stats?.hasnotindicated_percentage
                      )
                    " transform="rotate(-90 40 40)" />
                </svg>
                <div class="progress-label">
                    <div class="fw-bold">
                        {{ 100 - stats?.hasnotindicated_percentage }}%
                    </div>
                    <small class="fs-10">Availability<br />Indicated</small>
                </div>
            </div>
        </div>
    </div>
</div>
<ng-template #quickAvailabilityModal>
    <div class="modal-header">
        <h4 class="modal-title" id="exampleModalLabel">Quickly update your availability</h4>
        <button type="button" class="btn-close" (click)="closeModal()" aria-label="Close"></button>
    </div>

    <div class="modal-body pb-0">
        <div class="row align-items-center">
            <div class="col-md-12">
                <p class="txt-regular">We will mark you Available for the next 2 weeks, starting from tomorrow.</p>
            </div>
        </div>
    </div>
    <div class="modal-footer mt-10">
        <!-- <button type="button"  (click)="bsModalRef.hide()" class="btn_cc_back">Back</button> -->
        <button type="button" (click)="updateQuickAvailability()" class="btn cc_p_btn fs_13">
            Update availability
        </button>
    </div>
</ng-template>